import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Analytics } from '@vercel/analytics/react'
import App from './App'
import './index.css'
import './theme.css'

// Sentry: error tracking + replay-on-error.
// Disabled in dev so console errors don't burn the free-tier quota.
// Source maps are uploaded by @sentry/vite-plugin during prod builds (see vite.config.mjs).
Sentry.init({
  dsn: 'https://2406f64e590dd87b52352fe9acb923bf@o4511344553820160.ingest.us.sentry.io/4511344586129408',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.replayIntegration({
      // Default is masked PII — keep it on. Client names, addresses, phone
      // numbers shouldn't end up in Sentry replays.
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // No tracesSampleRate set — performance monitoring off (saves transaction
  // quota on free tier). Errors + replays only.
  replaysSessionSampleRate: 0,        // never record proactively
  replaysOnErrorSampleRate: 1.0,      // always record the 10s leading up to a crash
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <>
    <App />
    <Analytics />
  </>
)
